import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { url } from 'inspector';
import { title } from 'process';
import { element } from 'protractor';
import { Subject } from 'rxjs';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { DialogService } from 'src/app/services/dialog.service';
import { TemplateService } from 'src/app/services/template.service';

@Component({
  selector: 'app-dettaglio-template',
  templateUrl: './dettaglio-template.component.html',
  styleUrls: ['./dettaglio-template.component.css']
})
export class DettaglioTemplateComponent implements OnInit {

  denominazione: string;
  public isDettaglio: boolean;
  public form: FormGroup;
  public isModifica: boolean;
  public isNewTemplate: boolean;
  public tipologie: ModelEventiCalamitosi.CampoTipologieDTO[] = [];
  public formChanged: boolean;
  public templateName: string;
  public campoSubject: Subject<number> = new Subject<number>();
  public enteSubject: Subject<boolean> = new Subject<boolean>();
  public contrDesc: string;
  public contrTip: string;
  public campiPredConf: ModelEventiCalamitosi.CampoModuloDTO[] = [];
  public enti: ModelEventiCalamitosi.EnteDto[] = [];
  public templateEdit: ModelEventiCalamitosi.EditTemplateDTO;
  allAbilitatiCampi: string = '';
  allAbilitatiEnti: string = "";
  public checkPubblico: boolean;
  resetAbilitaTuttiEnti: Subject<boolean> = new Subject<boolean>();
  enteFilterDto: ModelEventiCalamitosi.EnteSearchableDto = {} as ModelEventiCalamitosi.EnteSearchableDto;
  atLeastOneModStatoComp: string = "";

  constructor(private router: Router, private dialogSvc: DialogService, private route: ActivatedRoute, private templateSvc: TemplateService, private alertsCenterService: AlertsCenterService) {
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      this.denominazione = this.router.getCurrentNavigation().extras.state.denominazione;
      console.log(this.denominazione)
    }
  }

  ngOnInit(): void {
    this.modeBooleanSetter();
    this.buildForm();
  }

  ngAfterViewInit() {
    let idEvento = this.route.snapshot.params.id;
    let idTemplate = this.route.snapshot.params.idTemplate ? this.route.snapshot.params.idTemplate : 0;
    setTimeout(() => {
      this.templateSvc.getTipologieTemplate(idEvento, idTemplate).toPromise().then(
        res => {
          this.tipologie = res;
          this.modeSelector();
        }
      )
        .then(x => {
          this.form.get('tpModulo').valueChanges.subscribe(selectedValue => {
            let tipoValue = this.form.get('tpModulo').value;
            if (tipoValue !== null) {
              this.formChanged = true;
            } else {
              this.formChanged = false;
            }
          })
        });
    });
  }

  buildForm() {
    this.form = new FormGroup({
      tpModulo: new FormControl({ value: null, disabled: this.isDettaglio && !this.isModifica }, [Validators.required]),
      descrizione: new FormControl({ value: null, disabled: this.isDettaglio && !this.isModifica }, [Validators.required, Validators.maxLength(2000)])
    });
    this.templateEdit = {
      template: {
        tpModulo: null,
        descrTpTemplate: null,
        descrizione: null,
        idEvento: this.route.snapshot.params.id,
        dtUltimaModifica: new Date(),
        flDistribuito: 'N',
        idTemplate: null,
        utenteUltimaModifica: 'utente test'
      },
      enteFilterDTO: null,
      campiPredConf: null,
      enti: null,
    }
    this.contrDesc = this.form.controls.descrizione.value;
    this.contrTip = this.form.controls.tpModulo.value;
    this.checkPubblico = true;
  }

  private buildFormDetail() {
    this.formChanged = true;
    this.templateSvc.getTemplate(this.route.snapshot.params.idTemplate).toPromise().then(res => {
      this.checkPubblico = res.flDistribuito == 'S' ? false : true;
      this.form = new FormGroup({
        tpModulo: new FormControl(res.tpModulo, [Validators.required]),
        descrizione: new FormControl({ value: res.descrizione, disabled: this.isDettaglio && !this.isModifica }, [Validators.maxLength(2000), Validators.required]),
      });
      this.templateName = res.descrizione
      this.templateEdit = {
        template: {
          tpModulo: res.tpModulo,
          descrTpTemplate: res.descrTpTemplate,
          descrizione: res.descrizione,
          idEvento: res.idEvento,
          dtUltimaModifica: new Date(),
          flDistribuito: res.flDistribuito,
          idTemplate: res.idTemplate,
          utenteUltimaModifica: res.utenteUltimaModifica
        },
        enteFilterDTO: null,
        campiPredConf: null,
        enti: null,
      }
      this.contrDesc = this.form.controls.descrizione.value;
      this.contrTip = this.form.controls.tpModulo.value;
      this.campoSubject.next(res.tpModulo);
      this.enteSubject.next(true);
    },
      err => {
        this.alertsCenterService.showAlert({
          message: err.error.esitoServizio.descrizioneEsito,
          type: 'danger',
          autoClosable: false
        });
        this.router.navigate(['/dettaglio-evento/' + this.route.snapshot.params.id + '/template-list']);
      }).then(x => {
        this.form.get('tpModulo').valueChanges.subscribe(selectedValue => {
          let tipoValue = this.form.get('tpModulo').value;
          if (tipoValue !== null) {
            this.formChanged = true;
          } else {
            this.formChanged = false;
          }
        })
      }
      );
  }

  private modeSelector() {
    this.isNewTemplate = this.router.url.endsWith('/nuovo-template') ? true : false;
    if (!this.isNewTemplate) {
      if (this.router.url.includes('modifica-template')) {
        this.isDettaglio = false;
        this.isModifica = true;
      } else if (this.router.url.includes('dettaglio-template')) {
        this.isModifica = false;
        this.isDettaglio = true;
      }
      this.buildFormDetail();
    } else this.isModifica = this.router.url.endsWith('/nuovo-template') ? true : false;

  }

  private modeBooleanSetter() {
    this.isNewTemplate = this.router.url.endsWith('/nuovo-template') ? true : false;
    if (!this.isNewTemplate) {
      if (this.router.url.includes('modifica-template')) {
        this.isDettaglio = false;
        this.isModifica = true;
      } else if (this.router.url.includes('dettaglio-template')) {
        this.isModifica = false;
        this.isDettaglio = true;
      }
    }
  }


  onNavigate() {
    let elencoTemplatePath;
    if (this.router.url.endsWith('/nuovo-template')) {
      elencoTemplatePath = this.router.url.replace('/nuovo-template', '');
    } else {
      if (this.route.snapshot.params.idTemplate != undefined || this.route.snapshot.params.idTemplate != null) {
        if (this.router.url.includes('modifica-template')) {
          elencoTemplatePath = this.router.url.replace('modifica-template/' + this.route.snapshot.params.idTemplate, '');
          //elencoTemplatePath = this.router.url.replace('/modifica-template', '');
        } else if (this.router.url.includes('dettaglio-template')) {
          elencoTemplatePath = this.router.url.replace('dettaglio-template/' + this.route.snapshot.params.idTemplate, '');
          //elencoTemplatePath = this.router.url.replace('/dettaglio-template', '');
        }
        this.router.navigate([elencoTemplatePath], { state: { denominazione: this.denominazione } });
      }
    }
    this.router.navigate([elencoTemplatePath], { state: { denominazione: this.denominazione } });
  }

  //Quando viene cambiato il valore della select di tipologia template questo cambiamento va notificato
  inviaTpModCampi(evt) {
    this.campoSubject.next(evt.value);
  }

  alertConfirm(event) {
    //event è l'evento di apertura/chiusura della select: true vuol dire che si sta aprendo, false che si sta chiudendo
    if (!this.isNewTemplate && event) {
      let title = 'Cambio tipologia';
      let message = 'Il cambio della tipologia del template può comportare la perdita di configurazioni di campi effettuate in precedenza';
      this.dialogSvc.openDialog(title, message)
    }
  }

  sonoAbilitatiTuttiCampi(allAbilitati: string) {
    this.allAbilitatiCampi = allAbilitati;
    if (allAbilitati === "S" || allAbilitati === "N") {
      this.campiPredConf = [];
    }
  }

  sonoAbilitatiTuttiEnti(allAbilitati: string) {
    this.allAbilitatiEnti = allAbilitati;
    if (allAbilitati === "S" || allAbilitati === "N") {
      this.enti = [];
    }
  }

  atLeastOneModStatoCompEntiEvent(atLeastOneModStatoComp: string) {
    this.atLeastOneModStatoComp = atLeastOneModStatoComp;
  }

  getEnteFilterDto(enteFilterDto: ModelEventiCalamitosi.EnteSearchableDto) {
    this.enteFilterDto = enteFilterDto;
  }

  upsertTemplate() {
    if (this.form.valid) {
      if (this.form.controls.tpModulo.value === this.contrTip
        && this.form.controls.descrizione.value === this.contrDesc
        && this.campiPredConf.length === 0
        && this.enti.length === 0
        && this.allAbilitatiCampi === ""
        && this.allAbilitatiEnti === "") {
        this.alertsCenterService.showAlert({
          message: `Nessuna modifica rilevata`,
          type: 'info',
          autoClosable: false
        });
      }
      else {
        var time = 100;
        if (this.atLeastOneModStatoComp == 'S') {
          this.alertsCenterService.showAlert({
            message: `Risultano selezionati enti di cui modificare lo stato compilazione!`,
            type: 'danger',
            autoClosable: false
          });
          var time = 2000;
        }
        setTimeout(() => {

          let shouldReloadPage = this.route.snapshot.params.idTemplate ? false : true;
          this.templateEdit.template.idTemplate = this.route.snapshot.params.idTemplate ? this.route.snapshot.params.idTemplate : null
          this.templateEdit.template.tpModulo = this.form.controls.tpModulo.value,
          this.templateEdit.template.descrizione = this.form.controls.descrizione.value,
          this.templateEdit.campiPredConf = this.campiPredConf.length !== 0 ? this.campiPredConf : null
          this.templateEdit.enti = this.enti.length !== 0 ? this.enti : null
          let newId: number;

          this.templateEdit.abilitaTuttiCampi = this.allAbilitatiCampi;
          this.templateEdit.abilitaTuttiEnti = this.allAbilitatiEnti;
          this.templateEdit.enteFilterDTO = this.enteFilterDto;

          this.templateSvc.upsertTemplate(this.templateEdit).subscribe(res => {
            newId = res.body.idTemplate;
            this.resetAbilitaTuttiEnti.next(true);
            if (this.templateEdit.template.idTemplate) {
              this.alertsCenterService.showAlert({
                message: `Modifica template effettuata con successo`,
                type: 'success',
                autoClosable: false
              });
            } else {
              this.alertsCenterService.showAlert({
                message: `Salvataggio template effettuato con successo`,
                type: 'success',
                autoClosable: false
              });
            }
            this.campiPredConf = [];
            this.enti = [];
            this.allAbilitatiCampi = "";
            this.allAbilitatiEnti = "";
            this.atLeastOneModStatoComp = "";
            //Deve esserci o eventSubject che ricarica la pag o il build form perchè il routing sulla stessa pag non ricarica i dati
            this.campoSubject.next(this.templateEdit.template.tpModulo);
            this.enteSubject.next(true);
            if (shouldReloadPage) this.router.navigate([this.router.url.replace("nuovo-template","modifica-template/") + newId]);
          },
            err => {
              this.alertsCenterService.showAlert({
                message: err.error.esitoServizio.descrizioneEsito,
                type: 'danger',
                autoClosable: false
              });
            });
        }, time);
      }
    } else {
      this.markAsTouched();
    }
  }

  fillCampiPredConf(event) {
    let present: boolean = false;
    if (this.campiPredConf.length > 0) {
      this.campiPredConf.forEach((element, index) => {
        if (element.idCampo === event.idCampo) {
          this.campiPredConf.splice(index, 1);
          present = true;
        }
      });
    }
    if (!present) this.campiPredConf.push(event);
  }

  fillEnti(event) {
    let present: boolean = false;
    if(event !== undefined) {
    if (this.enti.length > 0) {
      this.enti.forEach((element, index) => {
          if (element.descrizione == event.descrizione) {
          this.enti.splice(index, 1);
          present = true;
        }
      });
    }
    if (!present) this.enti.push(event);
    } else {
      this.enti = [];
      this.allAbilitatiEnti = "";
    }
  }
  markAsTouched() {
    if (this.router.url.includes('nuovo-template')) {
      this.form.controls.tpModulo.markAsTouched();
      if (this.formChanged) {
        this.form.controls.descrizione.markAsTouched();
      }
    } else {
      this.form.controls.tpModulo.markAsTouched();
      this.form.controls.descrizione.markAsTouched();
    }
  }

  // viene attivato la prima volta che rendo pubblico un
  // template, refresha i dati
  primaVoltaRendiPubblico(res: boolean) {
    if (res) {
      this.buildFormDetail();
      this.atLeastOneModStatoComp = '';
    }
  }
}
